import { render, staticRenderFns } from "./MaturedProductsChart.vue?vue&type=template&id=8cf2052c&scoped=true&"
import script from "./MaturedProductsChart.vue?vue&type=script&lang=js&"
export * from "./MaturedProductsChart.vue?vue&type=script&lang=js&"
import style0 from "./MaturedProductsChart.vue?vue&type=style&index=0&id=8cf2052c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf2052c",
  null
  
)

export default component.exports